import { MpQuestionReviewContent } from './MpQuestionReviewContent';
export default MpQuestionReviewContent;